/**
 * Forkortelsene i loggteksten, satt med store bokstaver.
 *
 * ========  HVORFOR DET MAA SKJE AUTOMATISK  ========
 *
 * «ALI for Alina» er det regi faktisk skriver, og rapporten slaar den
 * opp for aa vise hvem det var. Men regi skriver i mørket, med én
 * tommel, mens noe skjer — og skift-tasten er det foerste som ryker.
 * Brukeren 01.11.2026: «Om jeg legger til en deltaker med forkortelse,
 * saa oensker jeg at man skal kunne skrive chr i loggen, saa retter den
 * automatisk til store bokstaver.»
 *
 * ========  BARE ORD SOM ER FERDIGSKREVET  ========
 *
 * Retter man mens ordet skrives, blir «chrome» til «CHRome» ved den
 * tredje bokstaven. Derfor rettes bare ord som har et skilletegn eller
 * et mellomrom ETTER seg — da har skriveren forlatt ordet, og hen mente
 * det hen skrev.
 *
 * Det siste ordet i teksten rettes ikke mens man skriver. Det tas naar
 * posten lagres: `medSisteOrd`.
 *
 * ========  BARE DEM SOM FINNES  ========
 *
 * Lista er deltakerne i produksjonen. Et ord som ligner paa en
 * forkortelse, men ikke er en, roeres ikke — «ok» skal ikke bli «OK»
 * fordi noen heter Ola Kristiansen.
 */

/** Ordtegn: bokstaver og tall, med de norske. Ingenting annet. */
const ORD = /[\p{L}\p{N}]+/gu;

function sett(forkortelser: readonly string[]): Map<string, string> {
  const m = new Map<string, string>();
  for (const f of forkortelser) {
    const ren = f.trim();
    if (ren === "") continue;
    m.set(ren.toLowerCase(), ren.toUpperCase());
  }
  return m;
}

/**
 * Retter ferdigskrevne ord. Det siste ordet staar.
 *
 * Kalles ved hvert tastetrykk, saa den maa vaere billig: ett
 * gjennomloep over teksten og et oppslag per ord.
 */
export function medStoreForkortelser(
  tekst: string, forkortelser: readonly string[],
): string {
  const kjente = sett(forkortelser);
  if (kjente.size === 0) return tekst;

  return tekst.replace(ORD, (ord, plass: number) => {
    /* Siste ord i teksten: skriveren er kanskje ikke ferdig med det. */
    if (plass + ord.length >= tekst.length) return ord;
    return kjente.get(ord.toLowerCase()) ?? ord;
  });
}

/** Som over, men tar ogsaa det siste ordet. Brukes naar posten lagres. */
export function medSisteOrd(
  tekst: string, forkortelser: readonly string[],
): string {
  const kjente = sett(forkortelser);
  if (kjente.size === 0) return tekst;
  return tekst.replace(ORD, (ord) => kjente.get(ord.toLowerCase()) ?? ord);
}
